function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import i18n from '@pureartisan/simple-i18n';
import { FaFacebookF } from 'react-icons/fa';
import clsx from 'clsx';
import useStore from './../store';
import { CoreButton } from './../../../core';
import { onFacebookShare, constructShareLink } from './Share';

var FacebookShareBtn = function FacebookShareBtn(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]); // Generic store value setter.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  });
  var shareHash = useStore(function (state) {
    return state.shareHash;
  });
  var buttonTooltipPosition = useStore(function (state) {
    return state.buttonTooltipPosition;
  });
  var eventShareFacebook = useStore(function (state) {
    return state.eventShareFacebook;
  });

  var handleShare = function handleShare() {
    onFacebookShare(encodeURIComponent(constructShareLink(shareHash)), i18n.translate('DIALOG_SHARE_FACEBOOK'));
    setStoreValues({
      eventShareFacebook: eventShareFacebook + 1
    });
  };

  return /*#__PURE__*/React.createElement(CoreButton, {
    id: "button_share_facebook",
    label: i18n.translate("BUTTON_SHARE_FACEBOOK"),
    tooltip: props.tooltip ? buttonTooltipPosition : '',
    onClick: handleShare,
    color: "transparent",
    className: clsx(props.className, 'button-share-facebook button-share')
  }, /*#__PURE__*/React.createElement(FaFacebookF, null), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, i18n.translate("BUTTON_SHARE_FACEBOOK")), children);
};

export default FacebookShareBtn;